import Hero from "../sections/Hero";
import FeaturedProjects from "../sections/FeaturedProjects";
import Philosophy from "../sections/Philosophy";
import ServicesGrid from "../sections/ServicesGrid";
import WhySamora from "../sections/WhySamora";
import ProcessTimeline from "../sections/ProcessTimeline";
import Testimonials from "../sections/Testimonials";
import FAQ from "../sections/FAQ";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASection = () => (
    <section
        data-testid="home-cta-section"
        className="py-24 md:py-40 bg-samora-ink text-samora-bone"
    >
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 text-center">
            <p className="eyebrow text-samora-gold mb-6">
                Now booking · Q1 2025
            </p>
            <h2
                className="font-display leading-[0.95] tracking-tight max-w-4xl mx-auto"
                style={{ fontSize: "clamp(2.5rem, 6vw, 6rem)" }}
            >
                A studio takes on a few homes a year.<br />
                <span className="italic font-serif text-samora-gold">
                    Let's talk about yours.
                </span>
            </h2>
            <div className="mt-10 md:mt-14 flex justify-center">
                <Link
                    to="/contact"
                    data-testid="home-cta-final"
                    className="btn-samora bg-samora-bone text-samora-ink border-samora-bone hover:bg-samora-gold hover:text-white hover:border-samora-gold"
                >
                    Begin Your Home <ArrowRight size={16} />
                </Link>
            </div>
        </div>
    </section>
);

const Home = () => {
    return (
        <div data-testid="home-page">
            <Hero />
            <FeaturedProjects />
            <Philosophy />
            <ServicesGrid />
            <WhySamora />
            <ProcessTimeline />
            <Testimonials />
            <FAQ />
            <CTASection />
        </div>
    );
};

export default Home;
